import { object, string } from "yup";

export const profileUpdateSchema = object({
  first_name: string().required("Name is required"),
  calendar_url: string().url("Invalid URL format").nullable(),
  linkedIn_url: string().url("Invalid URL format").nullable(),
});
